import { useLocation } from 'react-router-dom'

export const useCurrentFullPath = () => {
  const location = useLocation()
  return location.pathname + location.search
}
